import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=660d434a&scoped=true"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=660d434a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660d434a",
  null
  
)

export default component.exports